import React, { PropsWithChildren } from 'react';
import { useDrop } from 'react-dnd';
import { ExternalUrlDragItemType } from 'app/area/external-url-groups/form/constants';
import styles from './external-url-drop.scss';
import { ExternalUrlItem } from 'app/area/external-url-groups/form/types-store';

interface ExternalUrlDropProps {
  item: ExternalUrlItem;
  type: ExternalUrlDragItemType;
  updateItem: (item: ExternalUrlItem, sequence: number) => void;
}

export const ExternalUrlDrop = ({
  item, type, updateItem, children
}: PropsWithChildren<ExternalUrlDropProps>) => {

  const [{ isHover }, dropRef] = useDrop({
    accept: type,
    drop: (_, monitor) => {
      const dragItem = monitor.getItem() as ExternalUrlItem;
      if (dragItem?.sequence !== item?.sequence) {
        updateItem(dragItem, item?.sequence);
      }
    },
    collect: (monitor) => ({
      isHover: monitor.isOver({ shallow: true })
    })
  });

  return <div ref={(node) => {
    dropRef(node);
  }} className={isHover ? styles.tileHover : undefined}>
    {children}
  </div>;
};
